import { homeHeroResponsiveUrls } from "../../lib/cdn-base.js";
import RapidmailNewsletterSection from "./rapidmail-newsletter-section.marko";
import CourseAudioStatus from "./course-audio-status.marko";

static const heroImg = homeHeroResponsiveUrls("/img/index/lernlaterne-new.png");

<div class="container">
  <section class="hero hero--home">
    <div class="hero__text">
      <p class="hero__eyebrow">${input.data.home.eyebrow}</p>
      <h1 class="hero__title">${input.data.home.heroTitle}</h1>
      <p class="hero__desc">${input.data.home.heroDescription}</p>
      <const/home=input.data.home>
      <const/langs=input.data.languages || {}>
      <if=(langs.german || langs.swiss)>
        <div class="hero__actions">
          <if=langs.german>
            <a class="btn btn--accent btn--lg" href=langs.german.href>${langs.german.label}</a>
          </if>
          <if=langs.swiss>
            <a class="btn btn--secondary btn--lg" href=langs.swiss.href>${langs.swiss.label}</a>
          </if>
        </div>
      </if>
      <if=(langs.others || []).length>
        <nav class="ll-home-langs" aria-label=home.targetLanguageCtaLabel>
          <p class="ll-home-langs__label">
            <span class="ll-home-langs__title">${home.otherLanguagesLabel}</span>
            <if=home.otherLanguagesHint>
              <span class="ll-home-langs__hint">${home.otherLanguagesHint}</span>
            </if>
          </p>
          <div class="hero__actions">
            <for|lang| of=langs.others>
              <a class="btn btn--secondary" href=lang.href title=lang.audioStatus?.tooltip aria-label=(lang.audioStatus ? `${lang.label} — ${lang.audioStatus.tooltip}` : undefined)>${lang.label}<CourseAudioStatus status=lang.audioStatus/></a>
            </for>
          </div>
        </nav>
      </if>
    </div>
    <div class="hero__media">
      <img
        src=heroImg.src
        srcset=heroImg.srcSet
        sizes=heroImg.sizes
        alt=(($global.locale || {}).seo?.siteName || "")
        class="hero__image"
        width="800"
        height="600"
        fetchpriority="high"
        onerror="this.style.display='none'"
      >
    </div>
  </section>
</div>

<section class="section section--home-about" style="background:var(--color-bg-card); border-top:1px solid var(--color-border); border-bottom:1px solid var(--color-border)">
  <div class="container">
    <div class="prose" style="max-width:860px; margin:0 auto">
      <p class="hero__eyebrow">${input.data.home.aboutProjectEyebrow}</p>
      <h2 class="section__title" style="margin-bottom:var(--space-md)">${input.data.home.aboutProjectTitle}</h2>
      <p class="about-section__text">${input.data.home.aboutProjectParagraph1}</p>
      <p class="about-section__text">${input.data.home.aboutProjectParagraph2}</p>
    </div>
  </div>
</section>

<section class="section section--home-about">
  <div class="container">
    <div class="prose" style="max-width:860px; margin:0 auto">
      <p class="hero__eyebrow">${input.data.home.aboutMeEyebrow}</p>
      <h2 class="section__title" style="margin-bottom:var(--space-md)">${input.data.home.aboutMeTitle}</h2>
      <p class="about-section__text">${input.data.home.aboutMeParagraph1}</p>
      <p class="about-section__text">${input.data.home.aboutMeParagraph2}</p>
      <p class="about-section__text">${input.data.home.aboutMeParagraph3}</p>
    </div>
  </div>
</section>

<section class="section ll-home-newsletter-band">
  <div class="container" style="max-width:860px">
    <RapidmailNewsletterSection newsletter=($global.locale && $global.locale.newsletter)/>
  </div>
</section>
